import React from 'react';
import PropTypes from 'prop-types';
import { Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Link } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Componente para mostrar y gestionar licencias asignadas a un producto
 */
const LicenciasAsignadas = ({
    objLicencias,
    product,
    orden,
    obtenerLicenciasParaModal,
    setseguroStateEliminar,
    idCatTipoUsuario
}) => {
    const { showErrorToast } = useToast();
    
    const esLicenciaAsignable = 
        product.vCodigoBarras === "LIC-SERV" ||
        product.vCodigoBarras === "LIC-NUB" ||
        product.vCodigoBarras === "LIC-CAJ" ||
        product.vCodigoBarras === "LIC-MEN-SERV" ||
        product.vCodigoBarras === "LIC-APP-COM" ||
        product.vCodigoBarras === "PAQ-STARTER-MEN-AKASIAPOS";

    const handleEliminarLicencia = (licencia) => {
        const estaActivada = licencia.Status?.startsWith("AC") || licencia.Status?.startsWith("VC");
        const esVendedor = idCatTipoUsuario === "3";

        if (estaActivada && esVendedor) {
            showErrorToast("No es posible desvincular una licencia que fue activada con esta orden, para hacerlo contacte a un administrador.");
            return;
        }

        setseguroStateEliminar({
            isOpen: true,
            idLicencia: licencia.idLicencia,
            idOrdenDetalle: product.idOrdenDetalle
        });
    };

    return (
        <>
            {objLicencias.map((objLicencia, index) => {
                const uniqueKey = objLicencia.idLicencia > 0
                    ? `lic-${product.idOrdenDetalle}-${objLicencia.idLicencia}`
                    : `lic-empty-${product.idOrdenDetalle}-${index}`;

                // Si tiene licencia asignada
                if (objLicencia.idLicencia > 0) {
                    return (
                        <Col key={uniqueKey} className="pr-1 mb-2" style={{ cursor: 'pointer' }}>
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip id="tooltip"><strong>Remover asignaci&oacute;n</strong></Tooltip>}
                            >
                                <FontAwesomeIcon
                                    className="me-2"
                                    onClick={() => handleEliminarLicencia(objLicencia)}
                                    icon={icon({ name: 'trash-can', style: "solid" })}
                                    style={{ color: "#c32847", cursor: 'pointer' }}
                                    size="lg"
                                />
                            </OverlayTrigger>

                            <Link
                                to={`/licencias/detalle/${objLicencia.idLicencia}`}
                                target="_blank"
                                className="stretched-link text-info position-relative"
                            >
                                <img className="mr-2" src="/img/pcautorizada20.png" alt="" />
                                {product.vCodigoBarras} #{objLicencia.idLicencia}
                            </Link>

                            {/* Badge de estado */}
                            {objLicencia.Status === "NO ACTIVADA" ? (
                                <span className="ms-2 badge badge-soft-danger">{objLicencia.Status}</span>
                            ) : objLicencia.Status?.includes("VC ") ? (
                                <span className="ms-2 badge badge-soft-warning">{objLicencia.Status}</span>
                            ) : (
                                <span className="ms-2 badge badge-soft-success">{objLicencia.Status}</span>
                            )}

                            {objLicencia.bCancelado === 1 && (
                                <>
                                    &nbsp;
                                    <span className="ms-2 badge badge-soft-danger">CANCELADA</span>
                                </>
                            )}
                        </Col>
                    );
                }

                // Si es un producto que permite asignar licencias y no tiene licencia
                if (esLicenciaAsignable) {
                    return (
                        <Col
                            key={uniqueKey}
                            className="pr-1 mb-2"
                            style={{ cursor: 'pointer' }}
                            onClick={() => obtenerLicenciasParaModal(
                                product.vCodigoBarras,
                                product.idOrdenDetalle,
                                orden.idClienteAkasia
                            )}
                        >
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip id="tooltip"><strong>Asignar licencia</strong></Tooltip>}
                            >
                                <span>
                                    <FontAwesomeIcon
                                        className="me-2"
                                        icon={icon({ name: 'file-contract', style: "solid" })}
                                        style={{ color: "#28a745" }}
                                        size="xl"
                                    />
                                    <span className="text-muted">
                                        Click para <strong>asignar licencia</strong>
                                    </span>
                                </span>
                            </OverlayTrigger>
                        </Col>
                    );
                }

                // Si no aplica ninguna condición, no renderizar nada
                return <Col key={uniqueKey} md={12}></Col>;
            })}
        </>
    );
};

LicenciasAsignadas.propTypes = {
    objLicencias: PropTypes.array.isRequired,
    product: PropTypes.object.isRequired,
    orden: PropTypes.object.isRequired,
    obtenerLicenciasParaModal: PropTypes.func.isRequired,
    setseguroStateEliminar: PropTypes.func.isRequired,
    idCatTipoUsuario: PropTypes.string.isRequired
};

export default LicenciasAsignadas;
